import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogTrigger } from '@radix-ui/react-dialog';
import '@radix-ui/themes/styles.css';
import ImageComponent from '../ImageComponent';
import { kababMenuOptions } from 'types/Constants';

const ActivityModal = (props) => {
  const sessionSettingData = useSelector((state:any) => state?.live.settings?.sessionSettingData);

  return (
    <Dialog open={props.visible} onOpenChange={props.onRequestClose}>
      <DialogContent
        className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center rounded-t-[4%]"
      >
        <div
          className="bg-white rounded-[3%] px-[3%] py-[3%] max-w-md w-full"
        >
          {/* Video Chat */}
          <button
            className="flex flex-row items-center my-[0.5%]"
            onClick={props.onVideoChat}
          >
            <ImageComponent
              source="/assets/videoOn.png"
              height={3.5}
              width={3.5}
              mode="contain"
              style={{ filter: 'hue-rotate(270deg) saturate(150%) brightness(80%)' }} // Approximates tintColor: rgba(95, 72, 138, 1)
            />
            <span
              className="text-[#6B5399] text-[4%] pl-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              {kababMenuOptions.START_VIDEO_CHAT}
            </span>
          </button>

          {/* Give a Badge */}
          <button
            className="flex flex-row items-center my-[0.5%]"
            onClick={props.onPressShareBadges}
          >
            <ImageComponent
              source="/assets/Badges.png"
              height={3.5}
              width={3.5}
              mode="contain"
              style={{ filter: 'hue-rotate(270deg) saturate(150%) brightness(80%)' }} // Approximates tintColor: rgba(95, 72, 138, 1)
            />
            <span
              className="text-[#6B5399] text-[4%] pl-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Give a Badge
            </span>
          </button>

          {/* Swap Seat */}
          <button
            className="flex flex-row items-center my-[0.5%] mt-[1%]"
            onClick={props.onPressSwapSeat}
          >
            <ImageComponent
              source="/assets/swapSeat.png"
              height={3.5}
              width={3.5}
              mode="contain"
              style={{tintColor: 'rgba(95, 72, 138, 1)'}}
            />
            <span
              className="text-[#6B5399] text-[4%] pl-[2%]"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Swap Seat
            </span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ActivityModal;